var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcScience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 30.48,
    height: 39.464,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_science",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(338.593 220.689)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1098",
    "data-name": "Rectangle 1098",
    width: 7.239,
    height: 11.659,
    transform: "translate(3.078 7.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1099",
    "data-name": "Rectangle 1099",
    width: 3.621,
    height: 11.659,
    transform: "translate(6.695 7.239)",
    fill: "#4b89c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214-2",
    "data-name": "Group 214",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21872",
    "data-name": "Path 21872",
    d: "M19.627,24.875a1.1,1.1,0,0,1-.182-.018.866.866,0,0,1-.666-1.031,13.69,13.69,0,0,0,.3-2.839,14.394,14.394,0,0,0-5.048-10.811A18.106,18.106,0,0,0,3.6,5.742a.868.868,0,1,1,.165-1.728A19.817,19.817,0,0,1,15.186,8.879a16.108,16.108,0,0,1,5.63,12.108,15.468,15.468,0,0,1-.34,3.2.871.871,0,0,1-.848.687",
    transform: "translate(7.06 10.047)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21873",
    "data-name": "Path 21873",
    d: "M8.736,15.212H1.5a.868.868,0,0,1-.866-.869V2.684A.868.868,0,0,1,1.5,1.818H8.736a.868.868,0,0,1,.869.866V14.343a.869.869,0,0,1-.869.869M2.366,13.477h5.5V3.553h-5.5Z",
    transform: "translate(1.581 4.555)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1100",
    "data-name": "Rectangle 1100",
    width: 4.823,
    height: 4.221,
    transform: "translate(4.284 18.898)",
    fill: "#6beaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21874",
    "data-name": "Path 21874",
    d: "M6.664,11.1H1.841a.868.868,0,0,1-.866-.869V6.01a.868.868,0,0,1,.866-.866H6.664a.868.868,0,0,1,.869.866V10.23a.869.869,0,0,1-.869.869M2.71,9.365H5.8V6.879H2.71Z",
    transform: "translate(2.443 12.888)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21875",
    "data-name": "Path 21875",
    d: "M.247,14.027H28.992V9.806H.247Z",
    transform: "translate(0.62 24.569)",
    fill: "#6beaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21876",
    "data-name": "Path 21876",
    d: "M29.611,15.515H.866A.868.868,0,0,1,0,14.645V10.425a.865.865,0,0,1,.866-.866H29.611a.866.866,0,0,1,.869.866v4.221a.869.869,0,0,1-.869.869M1.735,13.78H28.745V11.294H1.735Z",
    transform: "translate(0 23.95)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21877",
    "data-name": "Path 21877",
    d: "M12.528,14.858a.868.868,0,0,1-.869-.866V9.631H.869a.868.868,0,1,1,0-1.735H12.528a.869.869,0,0,1,.869.869v5.227a.868.868,0,0,1-.869.866",
    transform: "translate(0 19.783)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21878",
    "data-name": "Path 21878",
    d: "M5.112,14.858a.868.868,0,0,1-.869-.866V8.765A.869.869,0,0,1,5.112,7.9H15.566a.868.868,0,0,1,0,1.735H5.982v4.361a.868.868,0,0,1-.869.866",
    transform: "translate(10.631 19.783)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21879",
    "data-name": "Path 21879",
    d: "M1.246.247V2.894h.9V6.62h2.86V2.894h.9V.247Z",
    transform: "translate(3.121 0.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21880",
    "data-name": "Path 21880",
    d: "M5.625,8.108H2.765A.868.868,0,0,1,1.9,7.242L1.864,4.385A.868.868,0,0,1,1,3.516V.869A.868.868,0,0,1,1.864,0H6.526A.869.869,0,0,1,7.4.869V3.516a.869.869,0,0,1-.869.869H6.495V7.242a.868.868,0,0,1-.869.866M3.634,6.373H4.759V3.516a.865.865,0,0,1,.866-.866H5.66V1.735H2.733l.032.915a.866.866,0,0,1,.869.866Z",
    transform: "translate(2.5 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 10.387,
    height: 5.83,
    transform: "translate(15.806 28.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21881",
    "data-name": "Path 21881",
    d: "M15.518,15.461H5.128a.868.868,0,0,1-.866-.869V8.762A.868.868,0,0,1,5.128,7.9h10.39a.868.868,0,0,1,.866.866v5.83a.868.868,0,0,1-.866.869M6,13.726h8.651V9.635H6Z",
    transform: "translate(10.678 19.783)",
    fill: "#404040"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScience);
export default __webpack_public_path__ + "static/media/ic_science.7d8b028d5ec3786e2f70d7d0b46b369e.svg";
export { ForwardRef as ReactComponent };